import { FunctionComponent } from "react";
import { resetLocalStore } from "./Utils";
import { useAppDispatch } from "./store/hooks";
import { setWipeTransition } from "./store/wipeTransitionSlice";
import { useNavigate } from "react-router-dom";

export enum RoomConnectionErrorType {
  None = "None",
  NotFound = "NotFound",
  TooManyPlayers = "TooManyPlayers",
}

type RoomConnectionErrorProps = {
  type: RoomConnectionErrorType;
  roomCode: string;
};

const RoomConnectionError: FunctionComponent<RoomConnectionErrorProps> = ({
  type,
  roomCode,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  let headerText = null;
  let errorText = null;
  if (type === RoomConnectionErrorType.NotFound) {
    headerText = "Комната не найдена";
    errorText = "Не удалось найти комнату с кодом: ";
  } else {
    headerText = "Комната заполнена";
    errorText = "К комнате уже подключены два игрока: ";
  }

  return (
    <div className={"Room-connection-error-wrapper"}>
      <div className={"Room-connection-error-header"}>{headerText}</div>
      <div className={"Room-connection-error-text"}>
        {errorText}
        {<span className={"Room-connection-error-roomcode"}>{roomCode}</span>}
      </div>
      <div className={"Room-connection-error-subtext"}>
        Пожалуйста, проверьте код или попробуйте создать другую комнату.
      </div>
      <div className={"Room-connection-error-menu-button-wrapper"}>
        <button
          className={"Room-connection-error-menu-button"}
          onClick={() => {
            resetLocalStore(dispatch, true);
            dispatch(setWipeTransition(true));
            navigate("/");
          }}
        >
          Вернуться в меню
        </button>
      </div>
    </div>
  );
};

export default RoomConnectionError;
